import { useCallback, useState } from 'react';

import { type InfiniteData, useQueryClient } from '@tanstack/react-query';

import type { PageableContent } from '@cobliteam/common-types';
import type { GeofenceFilter, PlainGeofence } from '@cobliteam/common-types/src/geofenceV3';

import { QUERY_KEY as GEOFENCE_QUERY_KEY } from '@cobliteam/hooks/src/useEntity/useGeofenceV3';

import InputSearch from '../../../../../form/InputSearch';

const MINIMUN_TEXT_LENGTH = 2;

export interface GeofenceSearchProps {
  filters: GeofenceFilter;
  setFilters: (newFilters: GeofenceFilter) => void;
}

const GeofenceSearch = ({ filters, setFilters }: GeofenceSearchProps) => {
  const [isFilterUpdateEnabled, setIsFilterUpdateEnabled] = useState(false);
  const queryClient = useQueryClient();

  const updateTextFilter = useCallback(
    (newText: string) => {
      queryClient.setQueryData([...GEOFENCE_QUERY_KEY, 'LIST', filters], (old?: InfiniteData<PageableContent<PlainGeofence>>) =>
        old
          ? {
              pages: [old.pages[0]],
              pageParams: [old.pageParams[0]],
            }
          : undefined
      );
      setFilters({ ...filters, search: newText });
    },
    [filters, queryClient, setFilters]
  );

  const handleTextChange = useCallback(
    (value: string) => {
      if (!isFilterUpdateEnabled && value.length >= MINIMUN_TEXT_LENGTH) {
        setIsFilterUpdateEnabled(true);
        updateTextFilter(value);
      }

      if (isFilterUpdateEnabled) {
        updateTextFilter(value);
      }
    },
    [isFilterUpdateEnabled, updateTextFilter]
  );

  return <InputSearch placeholder='Procure por local' value={filters.search} autoFocus debounceInMillis={500} onChange={handleTextChange} className='w-full' />;
};

export default GeofenceSearch;
